import React, {Component} from 'react';
import classNames from 'classnames'
import './FJToolbarDevider.less';

class FJToolbarDevider extends Component {

    render() {
        let {active=true} = this.props;
        let containerCN = classNames('c-toolbar-divider-container', {active: active});
        return (
            <div className={containerCN}>
                <i className='c-toolbar-divider' />
            </div>
        );
    }
}

export default FJToolbarDevider;
